import React from 'react'
import PropTypes from 'prop-types'
import { DeleteAccountModalContainer } from './DeleteAccountModal.styles'
import CloseButton from 'components/CloseButton'
import CloseIcon from 'components/CloseIcon'
import { DeleteAccountModalContentContainer } from 'components/DeleteAccountModalContent'

const DeleteAccountModal = ({ onCloseModal, isModalOpen }) => (
  <DeleteAccountModalContainer
    data-testid="delete-account-content-wrapper"
    isModalOpen={isModalOpen}
  >
    <CloseButton
      data-testid="close-delete-account-modal-button"
      onClick={onCloseModal}
    >
      <CloseIcon />
    </CloseButton>
    <DeleteAccountModalContentContainer onCloseModal={onCloseModal} />
  </DeleteAccountModalContainer>
)

DeleteAccountModal.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseModal: PropTypes.func,
}

export default DeleteAccountModal



// WEBPACK FOOTER //
// ./src/components/DeleteAccountModal/DeleteAccountModal.js